<template>
<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5 10.1191V12.7858C14.5 13.1394 14.3595 13.4786 14.1095 13.7286C13.8594 13.9787 13.5203 14.1191 13.1667 14.1191H3.83333C3.47971 14.1191 3.14057 13.9787 2.89052 13.7286C2.64048 13.4786 2.5 13.1394 2.5 12.7858V10.1191" stroke="#56D0E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.16602 6.78516L8.49935 10.1185L11.8327 6.78516" stroke="#56D0E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.5 10.1191V2.11914" stroke="#56D0E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
